module.exports = __webpack_public_path__ + "images/4ca4aa41f273bc21b7ea30149b32acfb-IMG_4687.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living/IMG_4687.jpg
// module id = ./src/assets/images/slides/living/IMG_4687.jpg
// module chunks = 0